module.exports = __webpack_public_path__ + "img/1.cfba5fd7.jpg";